"use client"

import { useSidebar } from "@/components/ui/sidebar"

/** True when sidebar shows labels / dropdown chevrons (expanded desktop or mobile sheet). */
export function useSidebarExpandedMenuChrome(): boolean {
  const { state, isMobile } = useSidebar()
  return state === "expanded" || isMobile
}
